<template>
  <div class="shadow overflow-hidden rounded-lg">
    <div class="px-4 py-5 sm:px-6 border-gray-200 rounded-t-lg border bg-gray-50">
      <h3 class="text-lg leading-6 font-medium text-vice-teal-700" v-if="$slots.header">
        <slot name="header"></slot>
      </h3>
    </div>
    <div class="bg-white border rounded-b-lg border-t-0" v-if="$slots.content">
      <div class="px-4 py-5 sm:p-6">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoxCard',
};
</script>

<style scoped></style>
